import React, {Component} from 'react'
import { Header, Menu, Segment, Image, Grid, Icon, Button, Divider, Message, Embed, List, Tab, Container } from 'semantic-ui-react';
import GBMSlidesAccordion from './GBMSlidesAccordion';
import '../App.css'; 
import PhotosDisplay from './PhotosDisplay';

const Freshman1011 =
  "https://shpeuf.s3.amazonaws.com/public/resources/F1011_2026.png";
const Freshman1012 =
  "https://shpeuf.s3.amazonaws.com/public/resources/F1012_2026.png";
const Playlist =
  "https://shpeuf.s3.us-east-1.amazonaws.com/public/resources/SHPlaylist.png";
const Podcast = "https://shpeuf.s3.amazonaws.com/public/resources/SHPECast.jpg";
const Spotify = "https://shpeuf.s3.amazonaws.com/public/resources/spotify.jpg";
const Stitcher =
  "https://shpeuf.s3.amazonaws.com/public/resources/stitcher.png";
const CrashCourse =
  "https://shpeuf.s3.amazonaws.com/public/resources/ConventionCrashCourse.jpg";
const GradSHPEresearch =
  "https://shpeuf.s3.amazonaws.com/public/resources/GradSHPEresearch.png";
const GradSHPEschool =
  "https://shpeuf.s3.amazonaws.com/public/resources/GradSHPEschool.png";

const careerDB =
  "https://shpeuf.s3.amazonaws.com/public/resources/CD.png";
const internSHPE =
  "https://shpeuf.s3.amazonaws.com/public/resources/internshpe.png";

const f101ImageStyle = {
  width: '100%',
  maxWidth: '360px',
  maxHeight: '260px',
  height: 'auto',
  objectFit: 'contain',
  display: 'block',
  margin: '0 auto 1rem',
};

const GBMSlidesSegment = () => (
  <div>
    <br />
    <b>
      Missed a GBM or want to see any slides again? Find all the slides from
      this year's SHPE UF GBMs here.
    </b>
    <Grid divided centered>
      <Grid.Column width={10}>
        <GBMSlidesAccordion semesterYear="Fall 2025" />
        <GBMSlidesAccordion semesterYear="Spring 2026" />
      </Grid.Column>
    </Grid>
  </div>
);

const F101Segment = () => (
  <div>
    <br />
    <div style={{ maxWidth: '780px', margin: '0 auto 1rem', lineHeight: '1.5' }}>
      <b>
        We know entering college can be both exciting and overwhelming, so we
        have you covered. SHPE UF has put together this Freshman 101 Document
        Series with everything you should know as an incoming Gator. Learn from
        our members' advice and what they wish they knew as first-years.
      </b>
    </div>

    <Grid divided stackable centered>
      <Grid.Column mobile={16} tablet={8} computer={5} textAlign="center">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.75rem',
          }}
        >
          <h6>Getting Ready For UF</h6>

          <a
            href="https://drive.google.com/file/d/1IhebPFKdC0kvLkJHlUcVKz0K-cP0EuFU/view"
            target="_blank"
            rel="noreferrer"
            style={{ display: 'block', width: '100%', maxWidth: '240px', margin: '0 auto' }}
          >
            <img
              src={Freshman1011}
              alt="Getting Ready For UF"
              style={f101ImageStyle}
            />
          </a>

          <Button
            as="a"
            href="https://drive.google.com/file/d/1IhebPFKdC0kvLkJHlUcVKz0K-cP0EuFU/view"
            target="_blank"
            style={{ marginTop: '0.5rem' }}
          >
            <Icon name="download" />Download Here
          </Button>
        </div>
      </Grid.Column>

      <Grid.Column mobile={16} tablet={8} computer={5} textAlign="center">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.75rem',
          }}
        >
          <h6>Guide to Your First Semester</h6>
          <a
            href="https://drive.google.com/file/d/1T8zUsEiQ2k2YhK5e4QzNA5e-plZKXRg-/view"
            target="_blank"
            rel="noreferrer"
            style={{ display: 'block', width: '100%', maxWidth: '240px', margin: '0 auto' }}
          >
            <img
              src={Freshman1012}
              alt="Guide to Your First Semester"
              style={f101ImageStyle}
            />
          </a>

          <Button
            as="a"
            href="https://drive.google.com/file/d/1T8zUsEiQ2k2YhK5e4QzNA5e-plZKXRg-/view"
            target="_blank"
            style={{ marginTop: '0.5rem' }}
          >
            <Icon name="download" />Download here
          </Button>
        </div>
      </Grid.Column>

      <Grid.Column mobile={16} tablet={16} computer={16} textAlign="center">
        <h6>Keep an eye out for more coming in the future.</h6>
      </Grid.Column>
    </Grid>
  </div>
);

const MediaSegment = () => (
  <div>
    <Header block color="blue">
      Playlist and Podcast
    </Header>
    <Grid divided stackable>
      <Grid.Column width={5}>
        <h4> THE SHPlaylist</h4>
        <Image
          src={Playlist}
          as="a"
          size="medium"
          href="https://open.spotify.com/playlist/5LjBy5fbxKRmUfFAx16wsk?si=ylahvo97R1K7phdLhNXOtw"
          target="_blank"
        />
        <br />
        <b>Enjoy the official SHPE UF curated playlist</b>
        <a
          class="extra"
          href="https://open.spotify.com/playlist/5LjBy5fbxKRmUfFAx16wsk?si=ylahvo97R1K7phdLhNXOtw"
          target="_blank"
        >
          <b> here!</b>
        </a>
      </Grid.Column>
      <Grid.Column width={5}>
        <h4>SHPECast: Beyond Engineering</h4>
        <Image
          src={Podcast}
          as="a"
          size="medium"
          href="https://open.spotify.com/show/5RRjRsetNYP2UYDXr6hlsC"
          target="_blank"
        />
        <br />
        <b>
          In SHPECast: Beyond Engineering, University of Florida's SHPEitos talk
          about topics that go beyond engineering, give advice, and have fun
          with their SHPE Familia.
        </b>
        <br />
        <Menu compact>
          <Menu.Item
            href="https://open.spotify.com/show/5RRjRsetNYP2UYDXr6hlsC"
            target="_blank"
          >
            <Image src={Spotify} avatar />
            <b>Spotify</b>
          </Menu.Item>
          <Menu.Item
            href="https://listen.stitcher.com/yvap/?af_dp=stitcher://show/657597&af_web_dp=https://www.stitcher.com/show/657597"
            target="_blank"
          >
            <Image src={Stitcher} avatar />
            <b>Stitcher</b>
          </Menu.Item>
        </Menu>
      </Grid.Column>
      <Grid.Column width={5}>
        <h4>Episodes</h4>
        <List divided relaxed>
        <List.Item
            href="https://open.spotify.com/episode/7cL6CedBIliekDkqqU20OW?si=AHyEh_GwSLGdgchgSoX2sg"
            target="_blank"
          >
            <List.Icon name="spotify" color="black" />
            <List.Content>
              <b># 6- The Freshman Experience: Embracing Your First Year</b>
            </List.Content>
          </List.Item>
        <List.Item
            href="https://open.spotify.com/episode/0H1EBPEzE4rx1L6ee8Y5oL?si=paebmBGaTo6E_ovBNkUKrg"
            target="_blank"
          >
            <List.Icon name="spotify" color="black" />
            <List.Content>
              <b># 5- Interview Experience: Tips, Tricks, & Terrors</b>
            </List.Content>
          </List.Item>
          <List.Item
            href="https://open.spotify.com/episode/7HLm0AsslxrRNGU2PEfh2u?si=707f1ebe40994a8b"
            target="_blank"
          >
            <List.Icon name="spotify" color="black" />
            <List.Content>
              <b># 4- SHPEitos Abroad: Insider Scoop</b>
            </List.Content>
          </List.Item>
          <List.Item
            href="https://open.spotify.com/episode/3Qn5iGwCRDFcmLb7NfcGTF?si=4b1fecd077bb423e"
            target="_blank"
          >
            <List.Icon name="spotify" color="black" />
            <List.Content>
              <b># 3- From Directors to E-board: The Experience</b>
            </List.Content>
          </List.Item>
          <List.Item
            href="https://open.spotify.com/episode/1BB4kWtxklQNztzt8RLUV7?si=6f3dfeaf3c15422f"
            target="_blank"
          >
            <List.Icon name="spotify" color="black" />
            <List.Content>
              <b># 2- What Had Happened Was: Crazy Stories</b>
            </List.Content>
          </List.Item>
          <List.Item
            href="https://open.spotify.com/episode/4jx5Gp9tpZyHKwvAbm7xCC?si=4ed1766417054c9a"
            target="_blank"
          >
            <List.Icon name="spotify" color="black" />
            <List.Content>
              <b># 1- Transitioning to College: Perfectly Imperfect</b>
            </List.Content>
          </List.Item>
        </List>
      </Grid.Column>
    </Grid>
    {/* <Header block color='blue'>Photos</Header>
    <b>See photos from various SHPE UF events!</b>
    <Grid divided columns={3} stackable>
        <Grid.Column>
            <b>Spring 2022</b>
            <List animated>
                <List.Item href='https://drive.google.com/drive/folders/17KmyqavvRrn9rfnldstT6uRUil051G6Y' target='_blank'>
                    <b>Gala</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1UZQoHdAT3qE3cZK2RH4AgZ8OSJeeLphr' target='_blank'>
                    <b>Mural Day</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1PBQLN4uMLUsdzGMCUpAeMlcGot0mYPq8' target='_blank'>
                    <b>Elections GBM</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/15FxSRMkx6hcp-NUlsgixOmYilhdvlQ95?usp=sharing' target='_blank'>
                    <b>FYLP Painting Social</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1HsuJ1lcdz9d0YxDr3DDtchu_N2hJpNvI?usp=sharing' target='_blank'>
                    <b>SHPE Tank</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1OpxGLrLIS-LzFo2ncQc7_VXYOJDqskeQ?usp=sharing' target='_blank'>
                    <b>GFT</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1wFL0qbD00KB3ZtV3b73I1zcfO_OxOCjf?usp=sharing' target='_blank'>
                    <b>Pie The E-board</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1IsEj3jztpejqgrqWsT580ebYF1pvpzzw?usp=sharing' target='_blank'>
                    <b>Spring 2022 GBM #5</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1i8CigEQal-ZJbx4dkPICYtbQDWBXhIst?usp=sharing' target='_blank'>
                    <b>GFT Bingo</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/17-acVEIDQRlr6YslWaSONQYNCbhx2k58?usp=sharing' target='_blank'>
                    <b>MasterSHPE</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1SKm4Q1K5nE8Ex9dvuaN0Hh1G8fUDS7-L?usp=sharing' target='_blank'>
                    <b>Spring 2022 GBM #4</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/11-qJYvqSwg658qNpXNWji0ERvnjUX__5?usp=sharing' target='_blank'>
                    <b>Spring 2022 GBM #3</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1NGHUG6P4LYY_Ll1GBX9EksaSB7eUmyqJ?usp=sharing' target='_blank'>
                    <b>Valentines Day Social</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1_ndcDOr9zR7gEX3RaYi4qPOper1uqP6W?usp=sharing' target='_blank'>
                    <b>ShadowSHPE</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1VASympblkIO2u167EWggrbUf0iUey9EJ?usp=sharing' target='_blank'>
                    <b>BBQ Without Industry</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1PNHKA1-mCc603EsnBhzaQN5BGKOqGrEi?usp=sharing' target='_blank'>
                    <b>LeaderSHPE</b>
                </List.Item>
            </List>
        </Grid.Column>
        <Grid.Column>
            <b>Fall 2022</b>
            <List animated>
            <List.Item href='https://drive.google.com/drive/folders/1pyc9Q1w-_qOwAUdhy9NLZhR9K9JHLNso?usp=share_link' target='_blank'>
                    <b>SHPROM 2022</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1mJqrtauD6HU6zYe23ZOSnxoJjGSWwvbw?usp=share_link' target='_blank'>
                    <b>Fall 2022 GBM #6</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1YsGbDrwxr0etSG55vJmtzjRMwLL_kzKb?usp=share_link' target='_blank'>
                    <b>Bootcamp #3</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/14C6RXARf8mUtO02h_6IzNJ8XfMe6E3kR?usp=share_link' target='_blank'>
                    <b>Fall 2022 GBM #3</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1Iu6RjLXTp_ronvESY_SefYyK9_C3hJSG?usp=share_link' target='_blank'>
                    <b>Fall 2022 GBM #2</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1ozXrQ_SmGPLR-NUwbXmTSLVRgImkDsH6?usp=share_link' target='_blank'>
                    <b>Graduates Meet and Greet</b>
                </List.Item>
                <List.Item href='https://drive.google.com/drive/folders/1Mued25-ujpxJcaBtadPHRn7HtkE9ERuV?usp=share_link' target='_blank'>
                    <b>Study Abroad Info Session 2022</b>
                </List.Item>
                <Menu.Item href='https://drive.google.com/drive/folders/1yIkGUd2VqTCr8hKI1C7npFzOKYlR4zRu?usp=share_link' target='_blank'>
                    <b>Beyond LeaderSHPE #1</b>
                </Menu.Item>
                <List.Item href='https://drive.google.com/drive/folders/1FCHDFyf7gkh-81Vb-PaUN-mFGYstpTcf?usp=share_link' target='_blank'>
                    <b>LeaderSHPE Fall 2022</b>
                </List.Item>
            </List>
        </Grid.Column>
        <Grid.Column width={4}>
            <PhotosDisplay/>
        </Grid.Column>
    </Grid> */}
  </div>
);

// const CorporateSegment = () => (
//     <div>
//         <br/>
//         <b>Take advantage of our corporate resources to help you advance your professional career!</b>
//         <Divider horizontal>Convention Crash Course</Divider>
//         <Segment inverted>
//             <Embed
//             autoplay={false}
//             hd={true}
//             id='SK3FSh8f32o'
//             placeholder={CrashCourse}
//             source='youtube'
//             />
//         </Segment>
//         <Divider/>
//         <List animated>
//             <List.Item href='https://drive.google.com/drive/folders/1QsdfYtPfIhJkGTYfrep04DLOeBtf8X1G?usp=sharing' target='_blank'>
//                 <b>Bootcamp Workshop Slides</b>
//             </List.Item>
//             <List.Item href='https://docs.google.com/spreadsheets/d/1Ioi_U7l0gLhKZmeUtsWUR3qgjiG1PG_no9ID_2ZDe78/edit?usp=sharing' target='_blank'>
//                 <b>SHPEito LinkedIn Hub</b>
//             </List.Item>
//             <List.Item href='https://drive.google.com/drive/folders/1fAvthXv0F-dpHelVFYl_4NI2l_gOtoL4?usp=sharing' target='_blank'>
//                 <b>LinkedIn SHPE Banners</b>
//             </List.Item>
//             <List.Item href='https://docs.google.com/document/d/1HLDXHC0v_zzPuvR-t9SSbrt8qGsKVQTZ5Q-gcEKJTQA/edit?usp=sharing' target='_blank'>
//                 <b>Behavioral Interview Sample Questions</b>
//             </List.Item>
//             <List.Item href='https://drive.google.com/drive/folders/1gEGK280Y_oKACfFF_od9I-JC2gINS_3t?usp=sharing' target='_blank'>
//                 <b>Sample Resume Drive</b>
//             </List.Item>
//             <List.Item href='https://shpebbq.weebly.com/' target='_blank'>
//                 <b>BBQ With Industry Website</b>
//             </List.Item>
//         </List>
//     </div>
// )

const LinksSegment = () => (
  <div>
    <br />
    <b>Check out some of our additional resources with these links!</b>
    <Divider />
    <List animated>
      <List.Item
        href="https://linktr.ee/shpeuf?utm_source=linktree_profile_share&ltsid=606e08cd-0cad-412b-a9f8-252541adacc8 "
        target="_blank"
      >
        <b>Central SHPE UF Linktree</b>
      </List.Item>
      <List.Item href="https://linktr.ee/SHPEUFNationalConvention" target="_blank">
        <b>National Convention Linktree</b>
      </List.Item>
      <List.Item href="https://linktr.ee/shpeufbootcamp" target="_blank">
        <b>Professional Development & Resources</b>
      </List.Item>
      <List.Item
        href="https://drive.google.com/drive/folders/1aKXTC4mBIDnBR4NfBy9HbCmHCJ3AFjEh?usp=sharing"
        target="_blank"
      >
        <b>Academic SHPEducation Resources</b>
      </List.Item>
      <List.Item href="https://linktr.ee/gradshpeuf" target="_blank">
        <b>Graduate School & Research Resources</b>
      </List.Item>
      <List.Item
        href="https://drive.google.com/drive/folders/1PPqsURVaA1sOufVkdfjrgcwaXpGocBSO"
        target="_blank"
      >
        <b>SHPE Jr & Highschool Development Resources</b>
      </List.Item>
      <List.Item href="https://linktr.ee/shpeufchats" target="_blank">
        <b>SHPE Whatsapp Group Chats</b>
      </List.Item>
      <List.Item href="https://linktr.ee/shpeufphotos" target="_blank">
        <b>Event Photos</b>
      </List.Item>
    </List>
  </div>
);

const GradSegment = () => (
  <div>
    <br />
    <b>
      Want to delve deeper into the wonderful world of research and graduate
      studies? These documents will answer all of your questions when it comes
      to getting involved and succeeding as a researcher or graduate student!
    </b>
    <Grid divided centered>
        <Grid.Column width={5} textAlign='center'>
            <h6>Research Essentials</h6>
            <Image src={GradSHPEresearch} id='centered-img' as="a" size="medium" href="https://drive.google.com/file/d/19sO_QNUR64oGxbp3293Dy2ltChsAAUW-/view" target="_blank"/>
            <Divider/> 
            <Button as='a' href='https://drive.google.com/file/d/19sO_QNUR64oGxbp3293Dy2ltChsAAUW-/view' target="_blank"><Icon name='download'/>Download Here</Button>
        </Grid.Column>
        <Grid.Column width={5} textAlign='center'>
            <h6>Gradschool Essentials</h6>
            <Image src={GradSHPEschool} id='centered-img' as="a" href='https://drive.google.com/file/d/1iytv-CCITpX3xkSKI6kfkI1P09mbpxKc/view?usp=sharing' target="_blank" size="medium"/>
            <Divider/>
            <Button as='a' href='https://drive.google.com/file/d/1iytv-CCITpX3xkSKI6kfkI1P09mbpxKc/view?usp=sharing' target="_blank"><Icon name='download'/>Download here</Button>
            </Grid.Column>
        {/* <Grid.Column width={5}>
            <h6>Keep an eye out for more coming in the future.</h6>
        </Grid.Column> */}
    </Grid>
  </div>
);

const CorpSegment = () => (
  <div>
    <br />
    <b>
      Landing that first internship or dream job can be a challenging and competitive process, so we've got you covered! 
      Learn from our workshops and bootcamps on resume prep, delivering a powerful elevator pitch, acing your interviews, and mastering networking on platforms like LinkedIn. 
      We'll cover all the essentials of professionalism to help you build your confidence and secure your next opportunity!
    </b>
    <Grid divided centered>
        <Grid.Column width={5} textAlign='center'>
            <h6>Career Database</h6>
            <Image src={careerDB} id='centered-img' as="a" size="medium" href="https://drive.google.com/file/d/1esPYwC9Nvp39ZsF-gazUAnobZkkCm8Q5/view?usp=sharing" target="_blank"/>
            <Divider/> 
            <Button as='a' href='https://drive.google.com/file/d/1esPYwC9Nvp39ZsF-gazUAnobZkkCm8Q5/view?usp=sharing' target="_blank"><Icon name='download'/>Download Here</Button>
        </Grid.Column>
        <Grid.Column width={5} textAlign='center'>
            <h6>Internship ExSHPErience</h6>
            <Image src={internSHPE} id='centered-img' as="a" href='https://drive.google.com/file/d/1umQWHEPI6N9ZHsH1NOZ_RxS7haFywyZR/view?usp=sharing' target="_blank" size="medium"/>
            <Divider/>
            <Button as='a' href='https://drive.google.com/file/d/1umQWHEPI6N9ZHsH1NOZ_RxS7haFywyZR/view?usp=sharing' target="_blank"><Icon name='download'/>Download here</Button>
            </Grid.Column>
        {/* <Grid.Column width={5}>
            <h6>Keep an eye out for more coming in the future.</h6>
        </Grid.Column> */}
    </Grid>
  </div>
);

const ChapterByLawsSegment = () => (
  <div>
    <br />
    <Grid divided centered>
      <iframe
        width="100%"
        height="500"
        src="https://docs.google.com/document/d/e/2PACX-1vQBBrxARYgUI0p28xpkNS5G1P8_ngIt_W8qBMncPLpxhWZR-45HC4lhbIALmThwwg/pub?embedded=true"
      ></iframe>
    </Grid>
  </div>
);

const OpenRow = ({ rowName }) => {
  if (rowName == "Freshman 101 Slides") {
    return <F101Segment />;
  }
  if (rowName == "SHPE UF Media") {
    return <MediaSegment />;
  }
  if (rowName == "GBM Slides") {
    return <GBMSlidesSegment />;
  }
  // if(rowName == 'Corporate')
  //     return <CorporateSegment />
  if (rowName == "Links") {
    return <LinksSegment />;
  }
  if (rowName == "GradSHPE 101") {
    return <GradSegment />;
  }
  if (rowName == "Corp. Resources") {
    return <CorpSegment />;
  }
  if (rowName == "SHPE UF Bylaws") {
    return <ChapterByLawsSegment />;
  }
};

const panes = [
  {
    menuItem: "GBM Slides",
    render: () => (
      <Tab.Pane>
        <OpenRow rowName={"GBM Slides"} />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Freshman 101 Slides",
    render: () => (
      <Tab.Pane>
        <OpenRow rowName={"Freshman 101 Slides"} />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "GradSHPE 101",
    render: () => (
      <Tab.Pane>
        <OpenRow rowName={"GradSHPE 101"} />
      </Tab.Pane>
    ),
  },
   {
    menuItem: "Corp. Resources",
    render: () => (
      <Tab.Pane>
        <OpenRow rowName={"Corp. Resources"} />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "SHPE UF Media",
    render: () => (
      <Tab.Pane>
        <OpenRow rowName={"SHPE UF Media"} />
      </Tab.Pane>
    ),
  },
  //{ menuItem: 'Corporate', render: () => <Tab.Pane><OpenRow rowName={ 'Corporate' }/></Tab.Pane> },
  {
    menuItem: "Links",
    render: () => (
      <Tab.Pane>
        <OpenRow rowName={"Links"} />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "SHPE UF Bylaws",
    render: () => (
      <Tab.Pane>
        <OpenRow rowName={"SHPE UF Bylaws"} />
      </Tab.Pane>
    ),
  },
];

export default class ResourcesMenu extends Component {
  render() {
    return (
      <div class="wrap">
        <Container stackable>
          <Tab
            menu={{ stackable: true, tabular: true, attached: true }}
            panes={panes}
          />
        </Container>
      </div>
    );
  }
}
